import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { logoutUser } from '../../store/slices/authSlice';
import LogoutModal from './LogoutModal';
import { Capacitor } from '@capacitor/core';

const PublicNavbar: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const [showLogoutModal, setShowLogoutModal] = React.useState(false);

  return (
    <>
    <nav 
      className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-gray-100 dark:border-gray-800"
      style={{ paddingTop: 'max(var(--safe-area-inset-top, 0px), env(safe-area-inset-top, 0px))' }}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-2">
            <Link to={Capacitor.isNativePlatform() ? (user ? "/dashboard" : "/login") : "/"}>
              <BrandLogo iconSize="w-8 h-8" textSize="text-xl" />
            </Link>
        </div>
        <div className="flex items-center space-x-4">
          {/* [Subscription removed] Pricing link removed — platform is fully free. */}
          {/*  <Link*/}
          {/*      to="/pricing"*/}
          {/*      className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors"*/}
          {/*  >*/}
          {/*      Pricing*/}
          {/*  </Link> */}
          <Link
            to="/contact"
            className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors"
          >
            Contact
          </Link>
          {user ? (
            <>
              <Link 
                to="/profile" 
                className="text-sm font-medium bg-black dark:bg-white text-white dark:text-black px-5 py-2 rounded-full hover:bg-gray-800 dark:hover:bg-gray-200 transition-all transform hover:scale-105"
              >
                Profile
              </Link>
              <button
                onClick={() => setShowLogoutModal(true)}
                className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-red-600 dark:hover:text-red-400 transition-colors"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link 
                to="/login" 
                className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors"
              >
                Login
              </Link>
              <Link 
                to="/register" 
                className="text-sm font-medium bg-black dark:bg-white text-white dark:text-black px-5 py-2 rounded-full hover:bg-gray-800 dark:hover:bg-gray-200 transition-all transform hover:scale-105"
              >
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
    <LogoutModal
      isOpen={showLogoutModal}
      onClose={() => setShowLogoutModal(false)}
      onConfirm={() => {
        dispatch(logoutUser());
        navigate(Capacitor.isNativePlatform() ? '/login' : '/');
      }}
    />
    </>
  );
};

export default PublicNavbar;
